import React, { Component } from "react";

export class ClassModal extends Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    window.ClassModal = this;
  }
  render() {
    let { props } = this;
    let { id, title, onClose, contentClass } = props;
    let attrs = Object.except(props, ["id", "title", "type", "onClose"]);

    return (
      <AppModalBs id={id} title={title} onClose={onClose} contentClass={contentClass}>
        <AppFormData {...attrs} onClose={onClose}></AppFormData>
      </AppModalBs>
    );
  }
}

export default ClassModal;
